import React from 'react';
import * as S from './style';
import {
  Label,
  ChkBox,
  SelectBox,
  FormItem,
  FileImg,
  FormInput,
  BtnNext,
  ContentsContainer,
  BtnContainer,
} from 'components';
import { Props as InputProps } from 'components/atoms/Input';
import { Props as SelectBoxProps } from 'components/atoms/SelectBox';
import { Props as FileImgProps } from 'components/atoms/FileImg';
import FileImgListUploader, { Props as PartnerImagesProps } from 'components/molecules/FileImgListUploader';
import Introduce, {
  Props as IntroduceProps,
} from 'components/molecules/Introduce';
import ZimssaConstant from 'commons/ZimssaConstant';
import {
  TITLE_DEFAULT_INFO,
  TITLE_FIELD_PHOTO,
  TITLE_BUSINESS_INFO,
  CAPTION_START_YEAR,
  LABEL_STARTYEAR,
  LABEL_LOCATION,
  LABEL_LICENSE_IMG,
  LABEL_BUSINESS_REGISTRATION_NUMBER,
  LABEL_TAXCLASSIFICATION,
  LABEL_BUSINESS_REGISTRATION_IMG,
  LABEL_BUSINESS_REGISTRATION_OWNER,
  LABEL_LICENSE_NUMBER,
  PLACEHOLDER_SMALLMOVE_INTRODUCE,
} from 'commons/ZimssaString';

interface Props {
  introduce: IntroduceProps;
  location1: SelectBoxProps;
  location2: SelectBoxProps;
  startYear: SelectBoxProps;
  partnerServiceImages: PartnerImagesProps;
  businessRegistrationNumber: {
    inputProps: InputProps;
    caption: React.ReactNode | null;
    onChangeHandler: (type: any, value: string) => void;
  };
  taxClassification: {
    state: string;
    onClick: (
      e: React.MouseEvent<HTMLDivElement, MouseEvent>,
      value?: any
    ) => void;
  };
  businessRegistrationImage: FileImgProps;
  businessRegistrationOwner: {
    state: string;
    onClick: (
      e: React.MouseEvent<HTMLDivElement, MouseEvent>,
      value?: any
    ) => void;
  };
  familyRelationImage: FileImgProps;
  transportationLicenseNumber: {
    inputProps: InputProps;
    caption: React.ReactNode | null;
    onChangeHandler: (type: any, value: string) => void;
  };
  transportationLicenseImage: FileImgProps;
  btnNext: {
    contents: string;
    isActive: boolean;
    isComplete: boolean;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  };
}

function ServiceRegister({ ...props }: Props): React.ReactElement {
  return (
    <S.ServiceRegister>
      <ContentsContainer title={TITLE_DEFAULT_INFO}>
        <FormItem
          label={LABEL_STARTYEAR}
          caption={
            <Label
              contents={CAPTION_START_YEAR}
              color={'gray_opacity_600'}
              fontStyle={'caption'}
            />
          }
        >
          <SelectBox {...props.startYear} />
        </FormItem>
        <FormItem label={LABEL_LOCATION}>
          <SelectBox {...props.location1} />
          <SelectBox {...props.location2} />
        </FormItem>
        <FormItem label={TITLE_FIELD_PHOTO}>
          <FileImgListUploader {...props.partnerServiceImages} />
          <S.Divider />
        </FormItem>
        <Introduce
          {...props.introduce}
          placeholder={PLACEHOLDER_SMALLMOVE_INTRODUCE}
        />
      </ContentsContainer>
      <ContentsContainer title={TITLE_BUSINESS_INFO}>
        <FormInput
          inputType={'NUMBER'}
          label={LABEL_BUSINESS_REGISTRATION_NUMBER}
          maxLength={10}
          {...props.businessRegistrationNumber}
        />
        <FormItem label={LABEL_TAXCLASSIFICATION} itemType={'ROW'}>
          {ZimssaConstant.TAX_CLASSIFICATION.map((item, index) => (
            <ChkBox
              key={index}
              title={item.name}
              value={item.value}
              checked={item.value === props.taxClassification.state}
              {...props.taxClassification}
            />
          ))}
        </FormItem>
        <FormItem label={LABEL_BUSINESS_REGISTRATION_IMG}>
          <FileImg {...props.businessRegistrationImage} />
        </FormItem>
        <FormItem
          label={LABEL_BUSINESS_REGISTRATION_OWNER}
          itemType={'ROW'}
          optionalChildren={
            props.businessRegistrationOwner.state === '가족' ? (
              <FileImg {...props.familyRelationImage} />
            ) : null
          }
        >
          {ZimssaConstant.BUSINESS_REGISTRATION_OWNER.map((item, index) => (
            <ChkBox
              key={index}
              title={item.name}
              value={item.value}
              checked={item.value === props.businessRegistrationOwner.state}
              {...props.businessRegistrationOwner}
            />
          ))}
        </FormItem>
        <FormInput
          inputType={'NUMBER'}
          label={LABEL_LICENSE_NUMBER}
          maxLength={9}
          {...props.transportationLicenseNumber}
        />
        <FormItem label={LABEL_LICENSE_IMG}>
          <FileImg {...props.transportationLicenseImage} />
        </FormItem>
      </ContentsContainer>
      <BtnContainer>
        <BtnNext {...props.btnNext} />
      </BtnContainer>
    </S.ServiceRegister>
  );
}

export default ServiceRegister;
